export default __webpack_public_path__ + "static/media/mountain-3.0dba5050.png";